import { Button, Select } from "antd";
import { useIntl } from "react-intl";
import SubInfo from "../admin/common/SubInfo";

type Props = {
  services: any;
  setServices: any;
  handleSelectTeamMember: any;
  currentStep: any;
  getTeamMembersOptions: any;
};

const ListServices = ({
  services,
  setServices,
  handleSelectTeamMember,
  currentStep,
  getTeamMembersOptions,
}: Props) => {
  const intl = useIntl();
  const removeServicesItem = (index: number) => {
    const newServices = services.filter((e: any, i: any) => e.id !== index);
    setServices(newServices);
  };

  return (
    <div className="flex flex-col items-center w-full h-full gap-4">
      {services?.map((service: any, index: number) => (
        <div
          className="flex gap-2  bg-[#FBFBFF] p-2 justify-between rounded w-full"
          key={index}
        >
          <p className="flex items-center gap-1">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="12"
                viewBox="0 0 17 12"
                fill="none"
              >
                <path
                  d="M16.3866 5.86364C16.2844 5.79546 16.1821 5.76136 16.0798 5.72727C16.6934 4.70455 17.0003 3.81818 17.0003 3.06818C17.0003 1.36364 15.6366 0 13.9321 0C12.9434 0 12.0571 0.443182 11.5116 1.19318C10.9321 0.443182 10.0457 0 9.09118 0C7.38663 0 6.02299 1.36364 6.02299 3.06818C6.02299 3.78409 6.29572 4.60227 6.80708 5.52273C6.43208 5.72727 6.12527 6.03409 5.92072 6.375C5.68208 6.78409 5.27299 7.09091 4.79572 7.15909L3.43208 7.39773V6.95455C3.43208 6.75 3.29572 6.61364 3.09118 6.61364H0.943448C0.738903 6.61364 0.602539 6.75 0.602539 6.95455V11.6591C0.602539 11.8636 0.738903 12 0.943448 12H2.9889C3.19345 12 3.32981 11.8636 3.32981 11.6591V11.3864H7.69345C8.17072 11.3864 8.68208 11.3523 9.15936 11.25L11.1366 10.8409C12.0571 10.6364 12.9094 10.2955 13.6934 9.75L16.4548 7.90909C16.7957 7.67046 17.0003 7.29546 17.0003 6.88636C16.9662 6.47727 16.7616 6.10227 16.3866 5.86364ZM9.02299 0.681818C9.94345 0.681818 10.7616 1.19318 11.1707 2.01136C11.2389 2.11364 11.3412 2.21591 11.4775 2.21591C11.6139 2.21591 11.7162 2.14773 11.7844 2.01136C12.1934 1.19318 13.0116 0.681818 13.9321 0.681818C15.2616 0.681818 16.3184 1.77273 16.3184 3.06818C16.3184 3.81818 15.9434 4.73864 15.2275 5.82955L13.4548 6.75C12.6025 7.19318 11.6139 7.46591 10.6253 7.5L8.68208 7.56818C8.88663 7.125 9.26163 6.47727 9.84118 6.03409C10.3525 5.625 10.7275 5.07955 10.8639 4.46591V4.43182C10.898 4.19318 10.8298 3.95455 10.6253 3.78409C10.4207 3.64773 10.1821 3.61364 9.94345 3.71591C9.56845 3.88636 8.95481 4.22727 8.20481 4.67046C7.89799 4.875 7.62527 5.01136 7.38663 5.18182C6.94345 4.36364 6.70481 3.64773 6.70481 3.06818C6.63663 1.73864 7.69345 0.681818 9.02299 0.681818ZM2.64799 11.3182H1.28436V7.29545H2.64799V11.3182ZM16.0457 7.36364L13.2844 9.20455C12.5684 9.68182 11.8184 9.98864 10.9662 10.1932L8.9889 10.6023C8.54572 10.7045 8.10254 10.7386 7.69345 10.7386H3.32981V8.07955L4.79572 7.84091C5.47754 7.73864 6.05708 7.32955 6.39799 6.71591C6.53436 6.44318 6.77299 6.23864 7.01163 6.10227L7.28436 5.96591C7.65936 5.76136 8.06845 5.52273 8.51163 5.25C9.19345 4.80682 9.77299 4.53409 10.148 4.36364C10.0457 4.80682 9.77299 5.21591 9.39799 5.52273C8.30708 6.375 7.8639 7.77273 7.82981 7.84091C7.79572 7.94318 7.82981 8.04545 7.89799 8.14773C7.96617 8.25 8.06845 8.28409 8.17072 8.28409L10.6253 8.21591C11.7162 8.18182 12.773 7.90909 13.7275 7.39773L15.5003 6.47727C15.6707 6.375 15.8753 6.40909 16.0116 6.47727C16.1821 6.57955 16.2844 6.75 16.2844 6.92046C16.2844 7.09091 16.1821 7.26136 16.0457 7.36364Z"
                  fill="#00086D"
                />
              </svg>
            </span>
            <span>{service.name}</span>
          </p>
          <SubInfo
            value={service?.duration}
            label={intl.formatMessage({
              id: "minutes",
            })}
          />
          <div className="flex items-center gap-6">
            <SubInfo
              value={service?.price}
              label={intl.formatMessage({
                id: "SAR",
              })}
            />
            <Button
              type="text"
              htmlType="button"
              onClick={() => {
                removeServicesItem(service.id);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <path
                  d="M9.07544 4.57248L8.92544 9.1126C8.91266 9.50144 8.74886 9.86999 8.4688 10.14C8.18875 10.4101 7.81448 10.5604 7.42544 10.559H4.57544C4.18665 10.5604 3.8126 10.4103 3.53258 10.1406C3.25256 9.87085 3.0886 9.50268 3.07544 9.1141L2.92544 4.57248C2.92216 4.47302 2.95852 4.37634 3.02652 4.30369C3.09453 4.23104 3.18861 4.18839 3.28806 4.1851C3.38752 4.18182 3.48421 4.21818 3.55685 4.28619C3.6295 4.35419 3.67216 4.44827 3.67544 4.54773L3.82544 9.08898C3.83291 9.28284 3.91521 9.46627 4.05506 9.60074C4.19491 9.73521 4.38143 9.81025 4.57544 9.8101H7.42544C7.6197 9.81023 7.80643 9.73498 7.94632 9.6002C8.08621 9.46541 8.16835 9.28161 8.17544 9.08748L8.32544 4.54773C8.32872 4.44827 8.37138 4.35419 8.44402 4.28619C8.51667 4.21818 8.61336 4.18182 8.71281 4.1851C8.81227 4.18839 8.90635 4.23104 8.97435 4.30369C9.04236 4.37634 9.07872 4.47302 9.07544 4.57248ZM9.57156 3.0616C9.57156 3.16106 9.53205 3.25644 9.46173 3.32677C9.3914 3.39709 9.29602 3.4366 9.19656 3.4366H2.80469C2.70523 3.4366 2.60985 3.39709 2.53952 3.32677C2.4692 3.25644 2.42969 3.16106 2.42969 3.0616C2.42969 2.96215 2.4692 2.86676 2.53952 2.79644C2.60985 2.72611 2.70523 2.6866 2.80469 2.6866H3.96719C4.08601 2.68692 4.20069 2.64303 4.28893 2.56345C4.37717 2.48388 4.43264 2.37432 4.44456 2.2561C4.47224 1.97879 4.60216 1.7217 4.80902 1.53494C5.01589 1.34818 5.28487 1.24513 5.56356 1.24585H6.43731C6.71601 1.24513 6.98499 1.34818 7.19185 1.53494C7.39871 1.7217 7.52864 1.97879 7.55631 2.2561C7.56823 2.37432 7.62371 2.48388 7.71194 2.56345C7.80018 2.64303 7.91487 2.68692 8.03369 2.6866H9.19619C9.29564 2.6866 9.39103 2.72611 9.46135 2.79644C9.53168 2.86676 9.57119 2.96215 9.57119 3.0616H9.57156ZM5.09556 2.6866H6.90606C6.85678 2.57401 6.82456 2.4547 6.81044 2.3326C6.80115 2.24017 6.75788 2.15447 6.68901 2.09212C6.62015 2.02977 6.53059 1.9952 6.43769 1.9951H5.56394C5.47104 1.9952 5.38148 2.02977 5.31261 2.09212C5.24375 2.15447 5.20048 2.24017 5.19119 2.3326C5.17695 2.45472 5.14497 2.57403 5.09556 2.6866ZM5.47319 8.36823V5.1751C5.47319 5.07565 5.43368 4.98026 5.36335 4.90994C5.29303 4.83961 5.19764 4.8001 5.09819 4.8001C4.99873 4.8001 4.90335 4.83961 4.83302 4.90994C4.7627 4.98026 4.72319 5.07565 4.72319 5.1751V8.36973C4.72319 8.46918 4.7627 8.56457 4.83302 8.63489C4.90335 8.70522 4.99873 8.74473 5.09819 8.74473C5.19764 8.74473 5.29303 8.70522 5.36335 8.63489C5.43368 8.56457 5.47319 8.46918 5.47319 8.36973V8.36823ZM7.27844 8.36823V5.1751C7.27844 5.07565 7.23893 4.98026 7.1686 4.90994C7.09828 4.83961 7.00289 4.8001 6.90344 4.8001C6.80398 4.8001 6.7086 4.83961 6.63827 4.90994C6.56795 4.98026 6.52844 5.07565 6.52844 5.1751V8.36973C6.52844 8.46918 6.56795 8.56457 6.63827 8.63489C6.7086 8.70522 6.80398 8.74473 6.90344 8.74473C7.00289 8.74473 7.09828 8.70522 7.1686 8.63489C7.23893 8.56457 7.27844 8.46918 7.27844 8.36973V8.36823Z"
                  fill="#C43535"
                />
              </svg>
            </Button>
          </div>
          {currentStep > 1 ? (
            <div className="mt-3 rounded-select">
              <Select
                notFoundContent={
                  <p className="p-2 font-semibold text-center text-red-700">
                    {intl.formatMessage({
                      id: "selectTeamMemberWarningTextService",
                      defaultMessage:
                        "لا يوجد عضو متاح في هذا الوقت لهذه الخدمات يرجى تغيير الوقت",
                    })}
                  </p>
                }
                placeholder={intl.formatMessage({
                  id: "selectTeamMember",
                  defaultMessage: "اختر عضو الفريق",
                })}
                onChange={(id) => {
                  handleSelectTeamMember(
                    service?.id,
                    id as number | "lookfindr",
                    "service"
                  );
                }}
                className="  w-full rounded-full !bg-[#EEF0FF] h-12 "
                options={getTeamMembersOptions(service?.service_id, "service")}
              />
            </div>
          ) : (
            <div>dasdasd</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ListServices;
